/**
 * Checkbox Renderer
 * Features: single checkbox with label, required indicator
 */
import React from 'react';
import { Label } from '@/components/ui/label';
import { Checkbox } from '@/components/ui/checkbox';
import type { FieldRenderer } from '@/MyCode/core';

export const renderCheckbox: FieldRenderer = ({
    field,
    value,
    handleChange,
    isRequired
}) => (
    <div className="flex items-center space-x-2">
        <Checkbox
            id={field.name}
            checked={value || false}
            onCheckedChange={(checked) => handleChange(field.name, checked)}
        />
        <Label
            htmlFor={field.name}
            className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
        >
            {field.label}
            {isRequired && <span className="text-destructive ml-1">*</span>}
        </Label>
    </div>
);

export default renderCheckbox;